import { useState, useEffect, useCallback } from 'react';
import { goApi } from '../services';
import { apiRoutes } from '../services/apiRoutes';

export const useTestResult = (
    testId: string,
    mappingId: string,
    fetchOnDemand: boolean = false,
) => {
    const [testResult, setTestResult] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const fetchTestResult = useCallback(async () => {
        if (!testId || !mappingId) {
            setTestResult(null);
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const response = await goApi.get(apiRoutes.TEST_RESULT(testId, mappingId));

            if (response?.data) {
                setTestResult(response.data);
            } else {
                setTestResult(null);
            }
        } catch (err: any) {
            setError(err?.message || 'Failed to fetch test result');
            setTestResult(null);
        } finally {
            setLoading(false);
        }
    }, [testId, mappingId]);

    useEffect(() => {
        if (!fetchOnDemand) {
            fetchTestResult();
        }
    }, [testId, mappingId, fetchOnDemand, fetchTestResult]);

    return { testResult, loading, error, refetch: fetchTestResult };
};

export default useTestResult;
